module.exports = __webpack_public_path__ + "assets/img/box1.1cae57fa.png";